<section class="page-section overlay" id="branded-background">
    <div class="overlay-center-parent">
      <div class="overlay-center-child">
        <div class="row app-overlay">
          <div class="col-0 col-md-1 col-lg-2 col-xl-2 hide-xs-sm"></div>
          <div class="col-12 col-md-10 col-lg-8 col-xl-8">
            <div class="overlay-card overlay-card-button">
  
              <div class="row overlay-row">
                <div class="col-12">
                  <div class="row row-form form-banner form-banner-neutral-reverse">
                    <div class="col-3 col-sm-2 col-lg-3 col-xl-2 hide-xs text-align-center">
                      <div class="form-banner-center-parent">
                        <div class="form-banner-center-child">
                          <i class="fas fa-exclamation-circle fa-3x"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-9 col-sm-10 col-lg-9 col-xl-10 text-left">
                      <div class="form-banner-center-parent">
                        <div class="form-banner-center-child">
                          Your session has expired.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- <div class="row overlay-row"> -->
              <div class="row">
                <div class="col-12">
                  <p>We have not detected any activity for a while. For your protection, we are going to log you out.
                    Would you like to remain logged in and continue?</p>
                </div>
              </div>
  
              <!-- <div class="row overlay-row"> -->
              <div class="row">
                <div class="col-12 col-sm-6 btn-order-left text-align-center">
                  <button type="button" class="btn btn-secondary-v2 btn-margins btn-label btn-label-no" id="logMeOut"
                    (click)="logOut()"><span class="btn-icon btn-icon-no"></span></button>
                </div>
                <div class="col-12 col-sm-6 btn-order-right text-align-center">
                  <button type="button" class="btn btn-primary-v2 btn-margins btn-label btn-label-yes" id="staySignIn"
                    (click)="remainSignedIn()"><span class="btn-icon btn-icon-yes"></span></button>
                </div>
              </div>
  
            </div>
          </div>
          <div class="col-0 col-md-1 col-lg-2 col-xl-2 hide-xs-sm"></div>
        </div>
      </div>
    </div>
  </section>